<ngb-accordion #acc="ngbAccordion" [activeIds]="['chart','table']" class="small-accordion col-lg-12">
  <ngb-panel id="chart" title="Flow Instance">
    <ng-template ngbPanelHeader let-opened="opened">
      <div class="accordion-button px-2 py-1" [class.collapsed]="!opened">
        <div ngbPanelToggle class="d-lg-flex justify-content-between" (click)="acc.toggle('chart');">
          <span class="pointer"><strong>Flow Visualization</strong></span>
          <span class="pointer">
            <i class="mio vam" *ngIf="!opened">keyboard_arrow_down</i>
            <i class="mio vam" *ngIf="opened">keyboard_arrow_up</i>
          </span>
        </div>
      </div>
    </ng-template>
    <ng-template ngbPanelContent>
      <div style="height: 280px;" *ngIf="content && content.drawFlowData && content.drawFlowData.drawFlowData">
        <app-drawflow-graph *ngIf="initialized" [drawFlowData]="content.drawFlowData.drawFlowData" [action]="action"
          [edit]="false" [rawInspectData]="rawInspectData" [showInspectStats]="false"
          [closureSteps]="matchedClosureSteps" [inspectData]="content.flowInspectData"
          [edit]="false"></app-drawflow-graph>
      </div>
    </ng-template>
  </ngb-panel>
  <ngb-panel id="table" title="Flow Instance Details">
    <ng-template ngbPanelHeader let-opened="opened">
      <div class="accordion-button px-2 py-1" [class.collapsed]="!opened">
        <div ngbPanelToggle class="d-lg-flex justify-content-between" (click)="acc.toggle('table');">
          <span class="pointer"><strong>Flow Instance Details</strong></span>
          <span class="pointer">
            <i class="mio vam" *ngIf="!opened">keyboard_arrow_down</i>
            <i class="mio vam" *ngIf="opened">keyboard_arrow_up</i>
          </span>
        </div>
      </div>
    </ng-template>
    <ng-template ngbPanelContent>
      <table class="table table-sm table-hover table-striped table-sm table-outline table-event-details">
        <tbody>
          <tr *ngFor="let singleResultProperty of content.visibleFieldsMapping; let idx = index">
            <td style="width: 30px;">
              <div ngbDropdown class="d-inline-block no-arrow small" [autoClose]="true">
                <a ngbDropdownToggle><i class="mio vat pointer text-muted font-size-normal">more_vert</i></a>
                <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                  <button ngbDropdownItem
                    (click)="setQueryString(getProperty(singleResultProperty, content.searchResultProperties).key+': &quot;'+getProperty(singleResultProperty, content.searchResultProperties).value+'&quot;')"><i
                      class="mi vat mr-2">search</i>Search events with this field and
                    value</button>
                  <button ngbDropdownItem
                    (click)="setQueryString(getProperty(singleResultProperty, content.searchResultProperties).key+': *')"><i
                      class="mio vat mr-2">search</i>Search events with this field</button>
                  <button ngbDropdownItem
                    (click)="setQueryString('&quot;'+getProperty(singleResultProperty, content.searchResultProperties).value+'&quot;')"><i
                      class="mitt vat mr-2">search</i>Search events with this value</button>
                  <ng-container
                    *ngIf="content.fieldMappings[getProperty(singleResultProperty, content.searchResultProperties).key] && content.fieldMappings[getProperty(singleResultProperty, content.searchResultProperties).key].type != 'date'">


                  </ng-container>
                </div>
              </div>
            </td>
            <td style="min-width: 140px; width: 200px; overflow-x: auto; word-break: break-all;" class="text-left">
              <strong>{{content.visibleFieldsLabel[singleResultProperty] ?
                content.visibleFieldsLabel[singleResultProperty] : singleResultProperty}}</strong>
            </td>
            <td style="word-break: break-all;" [contextMenu]="eventDetailsContextMenu" [contextMenuSubject]="content">
              <ng-container
                *ngIf="!content.fieldMappings[getProperty(singleResultProperty, content.searchResultProperties).key]">
                <code class="color-dark"
                  [innerHtml]="getProperty(singleResultProperty, content.searchResultProperties).value"></code>
              </ng-container>
              <ng-container
                *ngIf="content.fieldMappings[getProperty(singleResultProperty, content.searchResultProperties).key] && content.fieldMappings[getProperty(singleResultProperty, content.searchResultProperties).key].type != 'date'&& content.fieldMappings[getProperty(singleResultProperty, content.searchResultProperties).key].type == 'number'">
                <code *ngIf="singleResultProperty != 'lastStep'" class="color-dark"
                  [innerHtml]="getProperty(singleResultProperty, content.searchResultProperties).value | number"></code>
              </ng-container>

              <ng-container
                *ngIf="getProperty(singleResultProperty, content.searchResultProperties).highlight != null && content.fieldMappings[getProperty(singleResultProperty, content.searchResultProperties).key] && content.fieldMappings[getProperty(singleResultProperty, content.searchResultProperties).key].type != 'date'&& content.fieldMappings[getProperty(singleResultProperty, content.searchResultProperties).key].type != 'number'">
                <code class=" color-dark text-highlight"
                  [ngClass]="{'modal-highlight': (getProperty(singleResultProperty, content.searchResultProperties).highlight == null || getProperty(singleResultProperty, content.searchResultProperties).highlight.length > 150)}"
                  [innerHtml]="getProperty(singleResultProperty, content.searchResultProperties).highlight || '-'"></code>
              </ng-container>

              <ng-container
                *ngIf="(getProperty(singleResultProperty, content.searchResultProperties).highlight == null || getProperty(singleResultProperty, content.searchResultProperties).highlight.length > 150) && (content.fieldMappings[getProperty(singleResultProperty, content.searchResultProperties).key] && content.fieldMappings[getProperty(singleResultProperty, content.searchResultProperties).key].type != 'date'&& content.fieldMappings[getProperty(singleResultProperty, content.searchResultProperties).key].type != 'number')">
                <code class="color-dark"
                  [innerHtml]="getProperty(singleResultProperty, content.searchResultProperties).value || '-'"></code>
                <code class="color-dark" *ngIf="singleResultProperty == 'lastStep'">
                ({{getStepNameByCode(getProperty(singleResultProperty, content.searchResultProperties).value)}})
                </code>
              </ng-container>

              <ng-container
                *ngIf="content.fieldMappings[getProperty(singleResultProperty, content.searchResultProperties).key] && content.fieldMappings[getProperty(singleResultProperty, content.searchResultProperties).key].type == 'date'">
                <code
                  class="color-dark">{{getProperty(singleResultProperty, content.searchResultProperties).value |  date: user.options['dateFormat'] : user.options['timeZone'] != 'Client default' ? user.options['timeZone'] : ''}} - ({{getProperty(singleResultProperty, content.searchResultProperties).value}})</code>
              </ng-container>
            </td>
          </tr>


        </tbody>
      </table>

      <context-menu #eventDetailsContextMenu>
        <ng-template contextMenuItem (execute)="setQueryString($event)">
          <i class="mio vam mr-1">search</i>Search events with this value
        </ng-template>
      </context-menu>
    </ng-template>
  </ngb-panel>
  <ngb-panel id="lineage" title="Data Lineage">
    <ng-template ngbPanelHeader let-opened="opened">
      <div class="accordion-button px-2 py-1" [class.collapsed]="!opened">
        <div ngbPanelToggle class="d-lg-flex justify-content-between"
          (click)="acc.toggle('lineage'); getDataLineage(getProperty('flowInstanceId', content.searchResultProperties).value)">
          <span class="pointer"><strong>Data Lineage</strong></span>
          <span class="pointer">
            <i class="mio vam" *ngIf="!opened">keyboard_arrow_down</i>
            <i class="mio vam" *ngIf="opened">keyboard_arrow_up</i>
          </span>
        </div>
      </div>
    </ng-template>
    <ng-template ngbPanelContent>
      <div style="min-height: 100px;">

        <div class="p-1" *ngIf="dataLineageIsLoading">
          <p><i class="mio text-muted spin vam mr-1">refresh</i>Loading Data Lineage data...</p>
        </div>
        <ngb-accordion #lineageAcc="ngbAccordion" [activeIds]="[]" class="small-accordion col-lg-12"
          *ngIf="!dataLineageIsLoading">
          <ng-container *ngFor="let stepCode of this.dataLineageMap|keyvalue">
            <ngb-panel [id]="'lineage-'+stepCode.key" [title]="stepCode.key">
              <ng-template ngbPanelHeader let-opened="opened">
                <div class="accordion-button custom-header px-2 py-1" [class.collapsed]="!opened">
                  <div ngbPanelToggle class="d-lg-flex justify-content-between"
                    (click)="lineageAcc.toggle('lineage-'+stepCode.key);">
                    <span class="pointer">
                      <span *ngIf="!isDataLineagePresentForStepCode(stepCode.key)"
                        class="badge badge-pill badge-secondary mr-1">&nbsp;</span>
                      <span *ngIf="isDataLineagePresentForStepCode(stepCode.key)"
                        class="badge badge-pill badge-success mr-1">&nbsp;</span>
                      {{getStepNameByCode(stepCode.key)}}</span>
                    <span class="pointer">
                      <i class="mio vam" *ngIf="!opened">keyboard_arrow_down</i>
                      <i class="mio vam" *ngIf="opened">keyboard_arrow_up</i>
                    </span>
                  </div>
                </div>
              </ng-template>
              <ng-template ngbPanelContent>
                <p *ngIf="!dataLineageMap[stepCode.key]">No Data Lineage data found for the selected instance</p>
                <div *ngIf="dataLineageMap[stepCode.key]">
                  <h5>Definition</h5>
                  <table class="table table-sm table-hover table-striped table-sm table-outline table-event-details">
                    <tbody>
                      <ng-container
                        *ngIf="dataLineageMap[stepCode.key].dataLineageDefinition && dataLineageMap[stepCode.key].dataLineageDefinition.dataLineageFields">
                        <tr
                          *ngFor="let dlRow of dataLineageMap[stepCode.key].dataLineageDefinition.dataLineageFields | keyvalue">
                          <td style="min-width: 140px; width: 200px; overflow-x: auto; word-break: break-all;"
                            class="text-left">
                            <strong>{{dlRow.key}}</strong>
                          </td>
                          <td style="word-break: break-all;">
                            {{dlRow.value}}
                          </td>
                        </tr>
                      </ng-container>
                      <ng-container *ngIf="!dataLineageMap[stepCode.key].dataLineageDefinition">
                        <tr>
                          <td style="min-width: 140px; width: 200px; overflow-x: auto; word-break: break-all;"
                            class="text-left">
                            <span>No Data Lineage definition found for the selected Flow Type</span>
                          </td>
                        </tr>
                      </ng-container>
                    </tbody>
                  </table>

                  <div class="row">
                    <div class="col-lg-6">
                      <h5>Processing Data</h5>
                      <table
                        class="table table-sm table-hover table-striped table-sm table-outline table-event-details mb-2">
                        <tbody>
                          <ng-container
                            *ngIf="dataLineageMap[stepCode.key].dataLineageProcessingIdResult && dataLineageMap[stepCode.key].dataLineageProcessingIdResult.dataLineageFields">
                            <tr
                              *ngFor="let dlRow of dataLineageMap[stepCode.key].dataLineageProcessingIdResult.dataLineageFields | keyvalue">
                              <td style="min-width: 140px; width: 200px; overflow-x: auto; word-break: break-all;"
                                class="text-left">
                                <strong>{{dlRow.key}}</strong>
                              </td>
                              <td style="word-break: break-all;">
                                {{dlRow.value}}
                              </td>
                            </tr>
                          </ng-container>
                        </tbody>
                      </table>
                    </div>
                    <div class="col-lg-6">
                      <h5>Record Data</h5>
                      <table
                        class="table table-sm table-hover table-striped table-sm table-outline table-event-details mb-2">
                        <tbody>

                          <ng-container *ngIf="dataLineageMap[stepCode.key].dataLineageFields">
                            <tr *ngFor="let dlRow of dataLineageMap[stepCode.key].dataLineageFields | keyvalue">
                              <td style="min-width: 140px; width: 200px; overflow-x: auto; word-break: break-all;"
                                class="text-left">
                                <strong>{{dlRow.key}}</strong>
                              </td>
                              <td style="word-break: break-all;">
                                {{dlRow.value}}
                              </td>
                            </tr>
                          </ng-container>
                        </tbody>
                      </table>
                    </div>
                    <div class="col-lg-12">
                      <h5>Raw event</h5>
                      <table
                        class="table table-sm table-hover table-striped table-sm table-outline table-event-details mb-2">
                        <tbody>
                          <ng-container *ngIf="dataLineageMap[stepCode.key].searchResultProperties">
                            <tr
                              *ngFor="let singleResultProperty of dataLineageMap[stepCode.key].searchResultProperties">
                              <td style="min-width: 140px; width: 200px; overflow-x: auto; word-break: break-all;"
                                class="text-left">
                                <strong>{{singleResultProperty.key}}</strong>
                              </td>
                              <td style="word-break: break-all;">
                                <ng-container *ngIf="!fieldMappings[singleResultProperty.key]">
                                  <code class="color-dark" [innerHtml]="singleResultProperty.value"></code>
                                </ng-container>
                                <ng-container
                                  *ngIf="fieldMappings[singleResultProperty.key] && fieldMappings[singleResultProperty.key].type != 'date'&& fieldMappings[singleResultProperty.key].type == 'number'">
                                  <code class="color-dark" [innerHtml]="singleResultProperty.value | number"></code>
                                </ng-container>

                                <ng-container
                                  *ngIf="singleResultProperty.highlight != null && fieldMappings[singleResultProperty.key] && fieldMappings[singleResultProperty.key].type != 'date'&& fieldMappings[singleResultProperty.key].type != 'number'">
                                  <code class=" color-dark text-highlight"
                                    [ngClass]="{'modal-highlight': (singleResultProperty.highlight == null || singleResultProperty.highlight.length > 150)}"
                                    [innerHtml]="singleResultProperty.highlight || '-'"></code>
                                </ng-container>

                                <ng-container
                                  *ngIf="(singleResultProperty.highlight == null || singleResultProperty.highlight.length > 150) && (fieldMappings[singleResultProperty.key] && fieldMappings[singleResultProperty.key].type != 'date'&& fieldMappings[singleResultProperty.key].type != 'number')">
                                  <code class="color-dark" [innerHtml]="singleResultProperty.value || '-'"></code>
                                </ng-container>

                                <ng-container
                                  *ngIf="fieldMappings[singleResultProperty.key] && fieldMappings[singleResultProperty.key].type == 'date'">
                                  <code
                                    class="color-dark">{{singleResultProperty.value |  date: user.options['dateFormat'] : user.options['timeZone'] != 'Client default' ? user.options['timeZone'] : ''}} - ({{singleResultProperty.value}})</code>
                                </ng-container>
                              </td>
                            </tr>
                          </ng-container>
                        </tbody>
                      </table>
                    </div>
                  </div>

                </div>

              </ng-template>
            </ngb-panel>
          </ng-container>

        </ngb-accordion>
      </div>
    </ng-template>
  </ngb-panel>
</ngb-accordion>